import React from 'react';

const Loading = ({ fullScreen = false, message = 'Loading...' }) => {
  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-90 z-50">
        <div className="text-center">
          <div className="spinner mx-auto text-primary-600 w-12 h-12 border-4"></div>
          <p className="mt-4 text-gray-600">{message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-12">
      <div className="text-center">
        <div className="spinner mx-auto text-primary-600"></div>
        <p className="mt-4 text-gray-600 text-sm">{message}</p>
      </div>
    </div>
  );
};

export default Loading;
